(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = true;
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
    document.addEventListener(
  'click',
  function (event) {
    const trigger = event.target.closest(
      '#shopify-section-header a, #shopify-section-header summary'
    );

    if (!trigger) return;

    const label = (trigger.textContent || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

    if (label === 'lookbook' || label === 'look book' || label === 'look') {
      event.preventDefault();
      event.stopPropagation();
      window.location.assign('/pages/lookbook');
      return;
    }

    if (label === 'tv show' || label === 'the show') {
      event.preventDefault();
      event.stopPropagation();

      document.querySelectorAll('#Details-menu-drawer-container[open]').forEach((drawer) => {
        drawer.removeAttribute('open');
        const summary = drawer.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      });

      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden-tablet');

      const onHomepage =
        window.location.pathname === '/' ||
        window.location.pathname === '' ||
        window.location.pathname === '/index' ||
        window.location.pathname === '/index.html';

      if (onHomepage) {
        const isDesktop = window.matchMedia('(min-width: 769px)').matches;
        const target = isDesktop
          ? document.querySelector('.original-tree-section') ||
            document.querySelector('#tree-tv-desktop') ||
            document.querySelector('#tree-tv')
          : document.querySelector('.custom-modal-section') ||
            document.querySelector('#tree-tv') ||
            document.querySelector('#tree-tv-mobile');

        if (target) {
          const rect = target.getBoundingClientRect();
          const absoluteTop = rect.top + window.pageYOffset;
          const stickyHeader =
            document.querySelector('#shopify-section-header .section-header') ||
            document.querySelector('.section-header') ||
            document.querySelector('.header-wrapper');
          const headerOffset = stickyHeader ? stickyHeader.getBoundingClientRect().height : 0;
          const visibleViewportHeight = window.innerHeight - headerOffset;
          const centeredTop =
            absoluteTop - headerOffset - Math.max((visibleViewportHeight - rect.height) / 2, 0);

          window.scrollTo({
            top: Math.max(centeredTop, 0),
            behavior: 'smooth'
          });

          window.history.replaceState(null, '', '#tree-tv');
          return;
        }
      }

      window.location.assign('/#tree-tv');
      return;
    }
  },
  true
);


  } catch(e) { console.error(e); }
})();
})();
